//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type

import com.apollographql.apollo.api.EnumType
import kotlin.Array
import kotlin.Deprecated
import kotlin.String
import kotlin.collections.List

public enum class FindingCategory(
  public val rawValue: String,
) {
  OBSERVATION("OBSERVATION"),
  MINOR_NC("MINOR_NC"),
  MAJOR_NC("MAJOR_NC"),
  /**
   * Auto generated constant for unknown enum values
   */
  UNKNOWN__("UNKNOWN__"),
  ;

  public companion object {
    public val type: EnumType =
        EnumType("FindingCategory", listOf("OBSERVATION", "MINOR_NC", "MAJOR_NC"))

    /**
     * All [FindingCategory] known at compile time
     */
    public val knownEntries: List<FindingCategory>
      get() = listOf(
        FindingCategory.OBSERVATION,
        FindingCategory.MINOR_NC,
        FindingCategory.MAJOR_NC)

    /**
     * Returns all [FindingCategory] known at compile time
     */
    @Deprecated(
      message = "Use knownEntries instead",
      replaceWith = ReplaceWith("this.knownEntries"),
    )
    public fun knownValues(): Array<FindingCategory> = knownEntries.toTypedArray()

    /**
     * Returns the [FindingCategory] that represents the specified [rawValue].
     * Note: unknown values of [rawValue] will return [UNKNOWN__]. You may want to update your schema instead of calling this function directly.
     */
    public fun safeValueOf(rawValue: String): FindingCategory = entries.find { it.rawValue == rawValue } ?: UNKNOWN__
  }
}
